var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonCompliant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9916 1H35.3333C37.3584 1 39 2.64163 39 4.66667V23.5867C39 25.6117 37.3584 27.2533 35.3333 27.2533H4.9916C2.9666 27.2533 1.325 25.6117 1.325 23.5867V4.66667C1.325 2.64163 2.9666 1 4.9916 1Z",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.415 27.2354V34.2204",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8916 27.2354V34.2204",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3999 34.2202H7.9065",
    stroke: "#0C1CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2864 7.34375H32.353C32.9053 7.34375 33.353 7.79147 33.353 8.34375V14.4104C33.353 14.9627 32.9053 15.4104 32.353 15.4104H26.2864C25.7341 15.4104 25.2864 14.9627 25.2864 14.4104V8.34375C25.2864 7.79147 25.7341 7.34375 26.2864 7.34375Z",
    fill: "#AFD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95312 7.34375H22.8198C23.3721 7.34375 23.8198 7.79147 23.8198 8.34375V14.4104C23.8198 14.9627 23.3721 15.4104 22.8198 15.4104H7.95312C7.40082 15.4104 6.95312 14.9627 6.95312 14.4104V8.34375C6.95312 7.79147 7.40082 7.34375 7.95312 7.34375Z",
    fill: "#AFD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.953 16.1436H32.353C32.9053 16.1436 33.353 16.5913 33.353 17.1436V19.5436C33.353 20.0958 32.9053 20.5436 32.353 20.5436H7.953C7.4007 20.5436 6.953 20.0958 6.953 19.5436V17.1436C6.953 16.5913 7.4007 16.1436 7.953 16.1436Z",
    fill: "#AFD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6618 2.00007C35.6621 2.00017 35.6624 2.00032 35.6629 2.00088L36.4517 2.78961C36.4522 2.79017 36.4524 2.79043 36.4525 2.79076C36.4526 2.79045 36.4526 2.79107 36.4525 2.79076C36.4524 2.79107 36.4522 2.79228 36.4517 2.79284L32.5182 6.72628L36.4517 10.6597C36.4522 10.6603 36.4524 10.6605 36.4525 10.6608C36.4526 10.6605 36.4526 10.6612 36.4525 10.6608C36.4524 10.6612 36.4522 10.6624 36.4517 10.6629L35.6629 11.4517C35.6624 11.4522 35.6621 11.4524 35.6618 11.4525C35.6621 11.4526 35.6615 11.4526 35.6618 11.4525C35.6615 11.4524 35.6603 11.4522 35.6597 11.4517L31.7263 7.51823L27.7928 11.4517C27.7923 11.4522 27.792 11.4524 27.7917 11.4525C27.792 11.4526 27.7914 11.4526 27.7917 11.4525C27.7914 11.4524 27.7902 11.4522 27.7896 11.4517L27.0009 10.6629C27.0003 10.6624 27.0002 10.6621 27.0001 10.6618C27 10.6621 27 10.6615 27.0001 10.6618C27.0002 10.6615 27.0003 10.6603 27.0009 10.6597L30.9343 6.72628L27.0009 2.79284C27.0003 2.79229 27.0002 2.79202 27.0001 2.7917C27 2.79201 27 2.79139 27.0001 2.7917C27.0002 2.7914 27.0003 2.79017 27.0009 2.78961L27.7896 2.00088C27.7902 2.00032 27.7904 2.00017 27.7908 2.00007C27.7905 1.99998 27.7911 1.99998 27.7908 2.00007C27.7911 2.00017 27.7923 2.00032 27.7928 2.00088L31.7263 5.93431L35.6597 2.00088C35.6603 2.00032 35.6615 2.00017 35.6618 2.00007C35.6615 1.99998 35.6621 1.99998 35.6618 2.00007Z",
    fill: "#FB8181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 36,
    fill: "white",
    transform: "matrix(-1 0 0 1 40 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonCompliant);
export default __webpack_public_path__ + "static/media/non-compliant.3ee0299980f03fa5e4a442f9ce25ee2f.svg";
export { ForwardRef as ReactComponent };